<template>
  <div
    @scroll="handleScroll"
    v-if="fileParts && fileParts.length > 0"
    class="file-image"
    ref="wrapScroll"
  >
    <!-- 已经分割完成的pdf、word文件 -->
    <div class="file-images">
      <img
        v-for="item in fileParts"
        v-lazy="item.partUrl"
        :key="item.partUrl"
        class="imgt"
      />
    </div>
  </div>
</template>

<script>
import { getFilePartsList } from "@/api/course.js";
export default {
  props: {
    id: {
      type: String,
      default: function() {
        return "";
      }
    },
    totalPart: {
      type: Number,
      default: 0 ////素材总数 ,
    }
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      fileParts: [], //20-12-16 文件分解成图片的数组
      isLoading: false
    };
  },
  created() {
    this.getFilePartsList();
  },
  watch: {
    id(newValue, oldValue) {
      this.pageNo = 1;
      this.fileParts = [];
      if (this.$refs.wrapScroll) {
        this.$refs.wrapScroll.scrollTop = 0;
      }
      this.getFilePartsList();
    }
  },
  methods: {
    //监听图片加载-滚动到底部，20-12-16
    handleScroll(e) {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //写后台加载数据的函数
        // console.log('距顶部' + scrollTop + '可视区高度' + windowHeight + '滚动条总高度' + scrollHeight)
        console.log("滚动到底部，加载更多数据");
        this.getFilePartsList();
      }
    },
    //获取已经分解的图片 20-12-16
    getFilePartsList() {
      if (this.fileParts.length >= this.totalPart) {
        //已经到最后
        return;
      }
      if (this.isLoading) {
        return;
      }
      let id = this.id;
      let obj = {
        id: id,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      this.isLoading = true;
      getFilePartsList(obj)
        .then(res => {
          this.isLoading = false;
          if (this.pageNo == 1) {
            this.fileParts = res.data;
          } else {
            this.fileParts = this.fileParts.concat(res.data);
          }
          this.pageNo++;
        })
        .catch(err => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.file-image {
  padding: 50px 50px 0 50px;
  height: calc(100vh - 80px);
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  text-align: center;
  .imgt {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/chapter-details/chapter-detail/chapter-detail-fileImages.vue